module.exports = __webpack_public_path__ + "static/img/header.030a7381.jpeg";